// Primary 1 Chinese Data - Part 1
// Based on Primary Chinese P1 Topics.txt

export const p1DataPart1 = {
  title: "小學一年級中文學習",
  description: "專為小學一年級學生設計的中文學習內容，培養基礎語文能力和閱讀理解",
  objectives: "建立基礎語文能力，培養閱讀興趣，掌握基本語法結構",
  focus: "重點學習數詞、量詞、形容詞等基礎語法，以及多種文體的閱讀理解",
  
  readingTypes: [
    "兒歌", "故事", "慰問卡", "童詩", "邀請卡", "感謝卡",
    "賀卡", "記事", "描寫人物", "記人", "童話故事", "寓言故事"
  ],
  
  languageUsage: [
    {
      title: "數詞及量詞",
      description: "學習數詞和量詞的搭配，掌握基本的數量表達",
      sampleQuestions: [
        {
          question: "選擇正確的量詞：一（ ）書",
          answer: "本",
          explanation: "『本』是用來計算書本的量詞。"
        },
        {
          question: "選擇正確的量詞：一（ ）花",
          answer: "朵",
          explanation: "『朵』是用來計算花朵的量詞。"
        },
        {
          question: "選擇正確的量詞：一（ ）筆",
          answer: "支",
          explanation: "『支』是用來計算筆的量詞。"
        },
        {
          question: "選擇正確的量詞：一（ ）桌子",
          answer: "張",
          explanation: "『張』是用來計算桌子的量詞。"
        },
        {
          question: "選擇正確的量詞：一（ ）椅子",
          answer: "把",
          explanation: "『把』是用來計算椅子的量詞。"
        },
        {
          question: "選擇正確的量詞：一（ ）蘋果",
          answer: "個",
          explanation: "『個』是用來計算蘋果的量詞。"
        },
        {
          question: "選擇正確的量詞：一（ ）魚",
          answer: "條",
          explanation: "『條』是用來計算魚的量詞。"
        },
        {
          question: "選擇正確的量詞：一（ ）貓",
          answer: "隻",
          explanation: "『隻』是用來計算動物的量詞。"
        },
        {
          question: "選擇正確的量詞：一（ ）車",
          answer: "輛",
          explanation: "『輛』是用來計算車輛的量詞。"
        },
        {
          question: "選擇正確的量詞：一（ ）房子",
          answer: "間",
          explanation: "『間』是用來計算房子的量詞。"
        }
      ]
    },
    {
      title: "形容詞",
      description: "學習形容詞的用法，掌握描述事物的詞語",
      sampleQuestions: [
        {
          question: "選擇正確的形容詞：這朵花很（ ）",
          answer: "漂亮",
          explanation: "『漂亮』是形容詞，用來描述花的外觀。"
        },
        {
          question: "選擇正確的形容詞：這個蘋果很（ ）",
          answer: "甜",
          explanation: "『甜』是形容詞，用來描述蘋果的味道。"
        },
        {
          question: "選擇正確的形容詞：這本書很（ ）",
          answer: "有趣",
          explanation: "『有趣』是形容詞，用來描述書的內容。"
        },
        {
          question: "選擇正確的形容詞：這個房間很（ ）",
          answer: "大",
          explanation: "『大』是形容詞，用來描述房間的大小。"
        },
        {
          question: "選擇正確的形容詞：這隻貓很（ ）",
          answer: "可愛",
          explanation: "『可愛』是形容詞，用來描述貓的特徵。"
        },
        {
          question: "選擇正確的形容詞：這個蛋糕很（ ）",
          answer: "好吃",
          explanation: "『好吃』是形容詞，用來描述蛋糕的味道。"
        },
        {
          question: "選擇正確的形容詞：這件衣服很（ ）",
          answer: "新",
          explanation: "『新』是形容詞，用來描述衣服的狀態。"
        },
        {
          question: "選擇正確的形容詞：這個公園很（ ）",
          answer: "美麗",
          explanation: "『美麗』是形容詞，用來描述公園的外觀。"
        },
        {
          question: "選擇正確的形容詞：這首歌很（ ）",
          answer: "好聽",
          explanation: "『好聽』是形容詞，用來描述歌曲的品質。"
        },
        {
          question: "選擇正確的形容詞：這個故事很（ ）",
          answer: "精彩",
          explanation: "『精彩』是形容詞，用來描述故事的內容。"
        }
      ]
    },
    {
      title: "形近字",
      description: "學習形近字的區別，掌握漢字的字形特點",
      sampleQuestions: [
        {
          question: "選擇正確的字：我喜歡（ ）書",
          answer: "讀",
          explanation: "『讀』是讀書的意思，注意與『賣』的區別。"
        },
        {
          question: "選擇正確的字：這（ ）花很漂亮",
          answer: "朵",
          explanation: "『朵』是量詞，注意與『躲』的區別。"
        },
        {
          question: "選擇正確的字：我（ ）家吃飯",
          answer: "回",
          explanation: "『回』是回家的意思，注意與『四』的區別。"
        },
        {
          question: "選擇正確的字：這（ ）書很有趣",
          answer: "本",
          explanation: "『本』是量詞，注意與『木』的區別。"
        },
        {
          question: "選擇正確的字：我（ ）媽媽去買菜",
          answer: "跟",
          explanation: "『跟』是跟隨的意思，注意與『根』的區別。"
        },
        {
          question: "選擇正確的字：這（ ）魚很新鮮",
          answer: "條",
          explanation: "『條』是量詞，注意與『修』的區別。"
        },
        {
          question: "選擇正確的字：我（ ）弟弟玩",
          answer: "和",
          explanation: "『和』是連詞，注意與『合』的區別。"
        },
        {
          question: "選擇正確的字：這（ ）貓很可愛",
          answer: "隻",
          explanation: "『隻』是量詞，注意與『知』的區別。"
        },
        {
          question: "選擇正確的字：我（ ）老師學習",
          answer: "向",
          explanation: "『向』是介詞，注意與『像』的區別。"
        },
        {
          question: "選擇正確的字：這（ ）車很新",
          answer: "輛",
          explanation: "『輛』是量詞，注意與『兩』的區別。"
        }
      ]
    },
    {
      title: "重組句子（單句）",
      description: "學習句子的基本結構，掌握句子的重組方法",
      sampleQuestions: [
        {
          question: "重組句子：我 / 喜歡 / 讀書",
          answer: "我喜歡讀書。",
          explanation: "按照主語+謂語+賓語的順序重組句子。"
        },
        {
          question: "重組句子：小明 / 在 / 公園 / 玩",
          answer: "小明在公園玩。",
          explanation: "按照主語+介詞+地點+謂語的順序重組句子。"
        },
        {
          question: "重組句子：媽媽 / 做 / 飯",
          answer: "媽媽做飯。",
          explanation: "按照主語+謂語+賓語的順序重組句子。"
        },
        {
          question: "重組句子：我 / 和 / 朋友 / 一起 / 玩",
          answer: "我和朋友一起玩。",
          explanation: "按照主語+連詞+賓語+副詞+謂語的順序重組句子。"
        },
        {
          question: "重組句子：老師 / 教 / 我們 / 中文",
          answer: "老師教我們中文。",
          explanation: "按照主語+謂語+間接賓語+直接賓語的順序重組句子。"
        },
        {
          question: "重組句子：我 / 喜歡 / 吃 / 蘋果",
          answer: "我喜歡吃蘋果。",
          explanation: "按照主語+謂語+動詞+賓語的順序重組句子。"
        },
        {
          question: "重組句子：小華 / 在 / 學校 / 讀書",
          answer: "小華在學校讀書。",
          explanation: "按照主語+介詞+地點+謂語的順序重組句子。"
        },
        {
          question: "重組句子：我 / 和 / 弟弟 / 看 / 電視",
          answer: "我和弟弟看電視。",
          explanation: "按照主語+連詞+賓語+謂語+賓語的順序重組句子。"
        },
        {
          question: "重組句子：爸爸 / 開 / 車",
          answer: "爸爸開車。",
          explanation: "按照主語+謂語+賓語的順序重組句子。"
        },
        {
          question: "重組句子：我 / 喜歡 / 畫 / 畫",
          answer: "我喜歡畫畫。",
          explanation: "按照主語+謂語+動詞+賓語的順序重組句子。"
        }
      ]
    },
    {
      title: "量詞",
      description: "學習各種量詞的用法，掌握正確的量詞搭配",
      sampleQuestions: [
        {
          question: "選擇正確的量詞：一（ ）書",
          answer: "本",
          explanation: "『本』是用來計算書本的量詞。"
        },
        {
          question: "選擇正確的量詞：一（ ）花",
          answer: "朵",
          explanation: "『朵』是用來計算花朵的量詞。"
        },
        {
          question: "選擇正確的量詞：一（ ）筆",
          answer: "支",
          explanation: "『支』是用來計算筆的量詞。"
        },
        {
          question: "選擇正確的量詞：一（ ）桌子",
          answer: "張",
          explanation: "『張』是用來計算桌子的量詞。"
        },
        {
          question: "選擇正確的量詞：一（ ）椅子",
          answer: "把",
          explanation: "『把』是用來計算椅子的量詞。"
        },
        {
          question: "選擇正確的量詞：一（ ）蘋果",
          answer: "個",
          explanation: "『個』是用來計算蘋果的量詞。"
        },
        {
          question: "選擇正確的量詞：一（ ）魚",
          answer: "條",
          explanation: "『條』是用來計算魚的量詞。"
        },
        {
          question: "選擇正確的量詞：一（ ）貓",
          answer: "隻",
          explanation: "『隻』是用來計算動物的量詞。"
        },
        {
          question: "選擇正確的量詞：一（ ）車",
          answer: "輛",
          explanation: "『輛』是用來計算車輛的量詞。"
        },
        {
          question: "選擇正確的量詞：一（ ）房子",
          answer: "間",
          explanation: "『間』是用來計算房子的量詞。"
        }
      ]
    }
  ]
};

// Primary 1 Chinese Data - Part 2
export const p1DataPart2 = {
  languageUsage: [
    {
      title: "承接複句",
      description: "學習承接複句的結構，掌握句子的連接方法",
      sampleQuestions: [
        {
          question: "選擇正確的連接詞：我喜歡讀書，（ ）我也喜歡畫畫。",
          answer: "而且",
          explanation: "『而且』用來連接兩個並列的意思。"
        },
        {
          question: "選擇正確的連接詞：小明很聰明，（ ）他很勤奮。",
          answer: "而且",
          explanation: "『而且』用來連接兩個並列的意思。"
        },
        {
          question: "選擇正確的連接詞：我喜歡紅色，（ ）我也喜歡藍色。",
          answer: "而且",
          explanation: "『而且』用來連接兩個並列的意思。"
        },
        {
          question: "選擇正確的連接詞：這本書很有趣，（ ）它很有用。",
          answer: "而且",
          explanation: "『而且』用來連接兩個並列的意思。"
        },
        {
          question: "選擇正確的連接詞：小華很可愛，（ ）她很聰明。",
          answer: "而且",
          explanation: "『而且』用來連接兩個並列的意思。"
        }
      ]
    },
    {
      title: "標點符號",
      description: "學習基本標點符號的用法，掌握標點符號的語法功能",
      sampleQuestions: [
        {
          question: "選擇正確的標點符號：我喜歡讀書（ ）",
          answer: "。",
          explanation: "句號用於表示句子的結束。"
        },
        {
          question: "選擇正確的標點符號：你喜歡什麼顏色（ ）",
          answer: "？",
          explanation: "問號用於表示疑問句。"
        },
        {
          question: "選擇正確的標點符號：哇（ ）真漂亮（ ）",
          answer: "！",
          explanation: "感嘆號用於表示感嘆句。"
        },
        {
          question: "選擇正確的標點符號：我喜歡紅色（ ）藍色（ ）綠色。",
          answer: "、",
          explanation: "頓號用於分隔並列的詞語。"
        },
        {
          question: "選擇正確的標點符號：他說（ ）我喜歡讀書（ ）",
          answer: "：",
          explanation: "冒號用於表示引語的開始。"
        }
      ]
    },
    {
      title: "助詞（結構助詞、時態助詞）",
      description: "學習助詞的用法，掌握助詞的語法功能",
      sampleQuestions: [
        {
          question: "選擇正確的助詞：我（ ）書",
          answer: "的",
          explanation: "『的』是結構助詞，用來連接形容詞和名詞。"
        },
        {
          question: "選擇正確的助詞：我喜歡（ ）書",
          answer: "的",
          explanation: "『的』是結構助詞，用來連接動詞和名詞。"
        },
        {
          question: "選擇正確的助詞：我（ ）讀書",
          answer: "在",
          explanation: "『在』是時態助詞，表示正在進行的動作。"
        },
        {
          question: "選擇正確的助詞：我（ ）讀過這本書",
          answer: "已經",
          explanation: "『已經』是時態助詞，表示完成的動作。"
        },
        {
          question: "選擇正確的助詞：我（ ）讀書",
          answer: "要",
          explanation: "『要』是時態助詞，表示將要進行的動作。"
        }
      ]
    },
    {
      title: "代詞",
      description: "學習代詞的用法，掌握代詞的語法功能",
      sampleQuestions: [
        {
          question: "選擇正確的代詞：（ ）喜歡讀書",
          answer: "我",
          explanation: "『我』是第一人稱代詞。"
        },
        {
          question: "選擇正確的代詞：（ ）喜歡畫畫",
          answer: "你",
          explanation: "『你』是第二人稱代詞。"
        },
        {
          question: "選擇正確的代詞：（ ）很聰明",
          answer: "他",
          explanation: "『他』是第三人稱代詞。"
        },
        {
          question: "選擇正確的代詞：（ ）很可愛",
          answer: "她",
          explanation: "『她』是第三人稱代詞。"
        },
        {
          question: "選擇正確的代詞：（ ）很漂亮",
          answer: "它",
          explanation: "『它』是第三人稱代詞，指代事物。"
        }
      ]
    },
    {
      title: "並列句（和/都/一起）",
      description: "學習並列句的結構，掌握並列句的連接方法",
      sampleQuestions: [
        {
          question: "選擇正確的連接詞：我（ ）弟弟一起玩",
          answer: "和",
          explanation: "『和』用來連接兩個並列的主語。"
        },
        {
          question: "選擇正確的連接詞：我們（ ）喜歡讀書",
          answer: "都",
          explanation: "『都』用來表示全部的意思。"
        },
        {
          question: "選擇正確的連接詞：我（ ）朋友一起吃飯",
          answer: "和",
          explanation: "『和』用來連接兩個並列的主語。"
        },
        {
          question: "選擇正確的連接詞：他們（ ）很聰明",
          answer: "都",
          explanation: "『都』用來表示全部的意思。"
        },
        {
          question: "選擇正確的連接詞：我（ ）媽媽一起買菜",
          answer: "和",
          explanation: "『和』用來連接兩個並列的主語。"
        }
      ]
    }
  ]
}; 